import { NavLink } from "react-router-dom";
import { useMemo } from "react";
import { motion } from "framer-motion";
import { createBadgeGraphic, type LocaleKey } from "../utils/svgPlaceholders";

const MotionNavLink = motion(NavLink);

interface MenuButtonProps {
  to: string;
  label: string;
  locale: LocaleKey;
  accent?: {
    start: string;
    end: string;
  };
  graphic?: string;
  onClick?: () => void;
}

export const MenuButton = ({
  to,
  label,
  locale,
  accent,
  graphic,
  onClick,
}: MenuButtonProps) => {
  const graphicSrc = useMemo(
    () =>
      createBadgeGraphic(label, {
        gradientStart: accent?.start,
        gradientEnd: accent?.end,
        width: 200,
        height: 62,
        radius: 20,
        fontSize: locale === "en" ? 20 : 24,
      }),
    [accent?.end, accent?.start, label, locale],
  );

  return (
    <MotionNavLink
      to={to}
      onClick={onClick}
      className={({ isActive }) =>
        [
          "menu-button",
          isActive ? "menu-button--active" : "",
          locale === "en" ? "menu-button--en" : "menu-button--zh",
        ]
          .filter(Boolean)
          .join(" ")
      }
      whileHover={{ scale: [null, 1.2, 1.1] }}
      whileTap={{ scale: 1.05 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
    >
      <img
        src={graphic ?? graphicSrc}
        alt={label}
        className="menu-button__image"
      />
    </MotionNavLink>
  );
};
